import Event from '@components/event/Event'
import { useAppSelector } from '@store/hooks'
import { selectEventById } from '@store/membership/EventReducer'
import { useParams } from 'react-router-dom'
import Page from '../../../components/Page/Page'

const BookingTab = () => {
  const { eventId } = useParams()
  const event = useAppSelector(selectEventById(Number(eventId)))

  if (!event) {
    return <></>
  }

  return (
    <Page>
      <Event.Stats model={event} />
    </Page>
  )
}

export default BookingTab
